var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRemoteAccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    stroke: "#545454",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 10.667h7.333m-10-5.333 2.334 2.333L3.333 10m-2 3.334h13.334a.667.667 0 0 0 .666-.667V3.334a.667.667 0 0 0-.666-.667H1.333a.667.667 0 0 0-.666.667v9.333c0 .368.298.667.666.667z",
    stroke: "{stroke}",
    strokeWidth: 1.333,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemoteAccess);
export default __webpack_public_path__ + "static/media/remoteAccess.6affab1d6d359fa0621456ef4d598347.svg";
export { ForwardRef as ReactComponent };